/**
 * Variant Image Filtering (Hybrid Approach)
 */
(function () {
  'use strict';

  function initVariantImageFilter() {
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;
    var productJsonEl = productSection.querySelector('[data-product-json]');
    if (!productJsonEl || !productJsonEl.innerHTML.trim()) return;
    var product;
    try { product = JSON.parse(productJsonEl.innerHTML); } catch (e) { return; }
    if (!product || !product.variants || !product.options || !product.handle) return;

    var colorOptionIndex = -1;
    var colorNames = ['color', 'colour', 'colors', 'colours'];
    for (var i = 0; i < product.options.length; i++) {
      var optName = typeof product.options[i] === 'string' ? product.options[i] : (product.options[i].name || '');
      if (colorNames.indexOf(optName.toLowerCase()) !== -1) { colorOptionIndex = i; break; }
    }
    if (colorOptionIndex === -1) return;

    var vidToColor = {};
    for (var v = 0; v < product.variants.length; v++) {
      vidToColor[product.variants[v].id] = product.variants[v].options[colorOptionIndex];
    }

    // 2026-10-03 page speed: /products/<handle>.json (93 KB on the Y-String) was fetched only for
    // images[].variant_ids. The page's own [data-product-json] has the same data: media (ordered,
    // image type, same filenames) + variants[].featured_media.id. Verified identical for the
    // Y-String and Boxers. Runs after DOMContentLoaded so Flickity has measured the gallery
    // before any slide gets .hide (the old fetch latency used to guarantee that by accident).
    function imagesFromPageJson(p) {
      var vidsByMedia = {};
      for (var v = 0; v < p.variants.length; v++) {
        var fm = p.variants[v].featured_media;
        if (fm && fm.id) { (vidsByMedia[fm.id] = vidsByMedia[fm.id] || []).push(p.variants[v].id); }
      }
      var out = [];
      for (var m = 0; m < (p.media || []).length; m++) {
        var md = p.media[m];
        if (md.media_type !== 'image' || !md.preview_image) continue;
        out.push({ id: md.id, position: md.position, src: md.preview_image.src, variant_ids: vidsByMedia[md.id] || [] });
      }
      return out;
    }
    var pageImages = imagesFromPageJson(product);
    new Promise(function (resolve) {
      if (document.readyState === 'complete') return resolve(pageImages);
      document.addEventListener('DOMContentLoaded', function () { resolve(pageImages); });
      window.addEventListener('load', function () { resolve(pageImages); });
    })
      .then(function (ajaxImages) {
        ajaxImages.sort(function (a, b) { return a.position - b.position; });
        var imageIdToColor = {};
        var lastAssignedColor = null;
        for (var i = 0; i < ajaxImages.length; i++) {
          var img = ajaxImages[i];
          var vids = img.variant_ids || [];
          if (vids.length > 0) {
            var color = vidToColor[vids[0]];
            if (color) { imageIdToColor[img.id] = color; lastAssignedColor = color; }
          } else if (lastAssignedColor) { imageIdToColor[img.id] = lastAssignedColor; }
        }
        var colorImageIds = {};
        var allMappedIds = {};
        for (var imgId in imageIdToColor) {
          var c = imageIdToColor[imgId];
          if (!colorImageIds[c]) colorImageIds[c] = [];
          colorImageIds[c].push(imgId.toString());
          allMappedIds[imgId.toString()] = true;
        }
        var slides = Array.prototype.slice.call(productSection.querySelectorAll('[data-media-slide]'));
        var thumbHolder = productSection.querySelector('[data-product-thumbs]');
        var thumbs = thumbHolder ? Array.prototype.slice.call(thumbHolder.querySelectorAll('[data-slideshow-thumbnail]')) : [];
        if (slides.length === 0) return;
        function normaliseSrc(url) {
          if (!url) return '';
          url = url.replace(/^https?:/, '').split('?')[0].replace(/_\d+x\d*\./, '.');
          return url.split('/').pop();
        }
        var srcToImageId = {};
        for (var p = 0; p < ajaxImages.length; p++) {
          srcToImageId[normaliseSrc(ajaxImages[p].src)] = ajaxImages[p].id.toString();
        }
        var slideImageIds = [];
        for (var s = 0; s < slides.length; s++) {
          var imgEl = slides[s].querySelector('img');
          if (imgEl) {
            var slideSrc = normaliseSrc(imgEl.src || imgEl.getAttribute('data-src') || imgEl.getAttribute('data-photoswipe-src') || '');
            slideImageIds.push(srcToImageId[slideSrc] || null);
          } else { slideImageIds.push(null); }
        }
        var slideIsVideo = [];
        for (var vi = 0; vi < slides.length; vi++) {
          var isVideo = !slideImageIds[vi] && slides[vi].getAttribute('data-type') !== 'image';
          slideIsVideo.push(isVideo);
          if (isVideo) {
            for (var prev = vi - 1; prev >= 0; prev--) {
              if (slideImageIds[prev] && imageIdToColor[slideImageIds[prev]]) {
                var inheritedColor = imageIdToColor[slideImageIds[prev]];
                var syntheticId = '__video_' + vi;
                slideImageIds[vi] = syntheticId;
                imageIdToColor[syntheticId] = inheritedColor;
                if (!colorImageIds[inheritedColor]) colorImageIds[inheritedColor] = [];
                colorImageIds[inheritedColor].push(syntheticId);
                allMappedIds[syntheticId] = true;
                break;
              }
            }
          }
        }
        function filterImages(selectedColor) {
          var allowedIds = colorImageIds[selectedColor] || [];
          // Restock safety (2026-10-20): a colour with no photo tagged to its variants would otherwise hide every
          // slide. Fall back to showing the whole gallery until its photos are tagged in admin.
          if (allowedIds.length === 0) {
            slides.forEach(function (slide) { slide.classList.remove('hide'); slide.classList.remove('variant-hero'); });
            thumbs.forEach(function (thumb) { thumb.classList.remove('hide'); });
            var sEl = productSection.querySelector('[data-product-slideshow]');
            if (sEl && sEl.classList.contains('flickity-enabled') && typeof Flickity !== 'undefined') { var fk = Flickity.data(sEl) || (window.FlickityFade && FlickityFade.data(sEl)); if (fk) { fk.reloadCells(); fk.select(0); } }
            return;
          }
          var allowedSet = {};
          for (var a = 0; a < allowedIds.length; a++) { allowedSet[allowedIds[a]] = true; }
          var visibleMediaIds = {};
          var firstVisibleSlide = null;
          slides.forEach(function (slide, index) {
            var imgId = slideImageIds[index];
            slide.classList.remove('variant-hero');
            if (!imgId || !allMappedIds[imgId]) {
              slide.classList.remove('hide');
              visibleMediaIds[slide.getAttribute('data-media-id')] = true;
              if (!firstVisibleSlide && !slideIsVideo[index]) firstVisibleSlide = slide;
            } else if (allowedSet[imgId]) {
              slide.classList.remove('hide');
              visibleMediaIds[slide.getAttribute('data-media-id')] = true;
              if (!firstVisibleSlide && !slideIsVideo[index]) firstVisibleSlide = slide;
            } else { slide.classList.add('hide'); }
          });
          if (firstVisibleSlide) firstVisibleSlide.classList.add('variant-hero');
          thumbs.forEach(function (thumb) {
            var mid = thumb.getAttribute('data-media-select');
            thumb.classList[visibleMediaIds[mid] ? 'remove' : 'add']('hide');
          });
          var slideshowEl = productSection.querySelector('[data-product-slideshow]');
          if (slideshowEl && slideshowEl.classList.contains('flickity-enabled') && typeof Flickity !== 'undefined') {
            var flkty = Flickity.data(slideshowEl) || (window.FlickityFade && FlickityFade.data(slideshowEl));
            if (flkty) { flkty.reloadCells(); flkty.select(0); }
          }
        }
        var slideshow = productSection.querySelector('[data-product-slideshow]');
        function showSkeleton() {
          if (!slideshow) return;
          var existing = slideshow.querySelector('.variant-skeleton-overlay');
          if (existing) existing.remove();
          var overlay = document.createElement('div');
          overlay.className = 'variant-skeleton-overlay';
          overlay.innerHTML = '<div class="skeleton-block"></div>';
          slideshow.appendChild(overlay);
        }
        function hideSkeleton() {
          if (!slideshow) return;
          var overlay = slideshow.querySelector('.variant-skeleton-overlay');
          if (overlay) { overlay.classList.add('fade-out'); setTimeout(function () { overlay.remove(); }, 200); }
        }
        var lastScrollY = null;
        var lastColor = null;
        productSection.addEventListener('theme:variant:change', function (event) {
          var variant = event.detail && event.detail.variant;
          if (!variant) return;
          var selectedColor = variant.options[colorOptionIndex];
          var colorChanged = selectedColor !== lastColor;
          lastColor = selectedColor;
          lastScrollY = window.scrollY;
          if (colorChanged) showSkeleton();
          setTimeout(function () {
            filterImages(selectedColor);
            if (lastScrollY !== null) { window.scrollTo(0, lastScrollY); lastScrollY = null; }
            if (colorChanged) setTimeout(hideSkeleton, 80);
          }, 0);
        });
        var urlParams = new URLSearchParams(window.location.search);
        var urlVariantId = urlParams.get('variant');
        var currentVariant;
        if (urlVariantId) {
          for (var vi = 0; vi < product.variants.length; vi++) {
            if (product.variants[vi].id.toString() === urlVariantId) { currentVariant = product.variants[vi]; break; }
          }
        }
        if (!currentVariant) {
          for (var vj = 0; vj < product.variants.length; vj++) {
            if (product.variants[vj].available) { currentVariant = product.variants[vj]; break; }
          }
          if (!currentVariant) currentVariant = product.variants[0];
        }
        if (currentVariant) {
          setTimeout(function () { filterImages(currentVariant.options[colorOptionIndex]); }, 300);
        }
      })
      .catch(function (err) { console.error('[VariantFilter] Failed to map product images:', err); });
  }

  function moveSizeChart(attempt) {
    attempt = attempt || 0;
    var sizeWrapper = document.querySelector('[data-select-label="Size"]');
    var kiwiChart = document.querySelector('.ks-chart-container');
    if (sizeWrapper && kiwiChart) { sizeWrapper.appendChild(kiwiChart); }
    else if (attempt < 10) { setTimeout(function () { moveSizeChart(attempt + 1); }, 300); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initVariantImageFilter(); moveSizeChart(); });
  } else { initVariantImageFilter(); moveSizeChart(); }
})();

/**
 * Open UpCart Drawer on Add-to-Cart
 *
 * FIX (2026-05-21): Added window.theme guard to prevent
 * "Cannot read properties of undefined" JS errors that Clarity
 * was recording on 43% of sessions. The theme:cart:popdown event
 * can fire before window.theme is guaranteed to be fully initialised
 * in some app-injected contexts (Plerdy, etc.). We now bail safely
 * instead of throwing.
 */
(function () {
  'use strict';

  function getCartUrl() {
    // Safe accessor — returns null if window.theme isn't ready yet
    try {
      return window.theme && window.theme.routes && window.theme.routes.cart
        ? window.theme.routes.cart
        : null;
    } catch (e) {
      return null;
    }
  }

  function openUpcart() {
    var upcartOpen =
      document.querySelector('.upcart-icon') ||
      document.querySelector('[data-upcart-toggle]') ||
      document.querySelector('.upcart-trigger');
    if (upcartOpen) {
      upcartOpen.click();
      return;
    }
    var cartIcon = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (cartIcon) cartIcon.click();
  }

  function initCartDrawerOnAdd() {
    document.addEventListener('theme:cart:popdown', function (e) {
      e.stopImmediatePropagation();
      e.stopPropagation();

      // Hide the popdown bar if visible
      var popdown = document.querySelector('[data-product-add-popdown-wrapper]');
      if (popdown) popdown.classList.remove('is-visible');

      // Guard: bail if window.theme.routes isn't available yet
      var cartUrl = getCartUrl();
      if (!cartUrl) {
        // theme not ready — just open UpCart directly
        setTimeout(openUpcart, 100);
        return;
      }

      fetch(cartUrl + '.js', {
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('theme:cart:change', {
              detail: { cart: cart },
              bubbles: true
            })
          );
          setTimeout(openUpcart, 300);
        })
        .catch(function (err) {
          console.error('[SpicyWear] Cart drawer open error:', err);
          // Even on error, try to open the cart
          setTimeout(openUpcart, 300);
        });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerOnAdd);
  } else {
    initCartDrawerOnAdd();
  }
})();

/**
 * ShipProtect Price Decimal Fix
 * Patches Shopify.formatMoney so ShipProtect's price always
 * renders with 2 decimal places.
 */
(function () {
  'use strict';

  function patchFormatMoney() {
    if (!window.Shopify || !window.Shopify.formatMoney) {
      setTimeout(patchFormatMoney, 50);
      return;
    }

    var _original = window.Shopify.formatMoney;

    window.Shopify.formatMoney = function (cents, format) {
      var centsInt = typeof cents === 'string'
        ? parseInt(cents.replace('.', ''), 10)
        : Math.round(parseFloat(cents) * (String(cents).indexOf('.') !== -1 ? 100 : 1));

      if (centsInt % 100 !== 0) {
        var dollars = (centsInt / 100).toFixed(2);
        var symbol = '$';
        if (format) {
          var symMatch = format.match(/^([^{]+)/);
          if (symMatch) symbol = symMatch[1];
        } else if (window.Shopify.money_format) {
          var sfMatch = window.Shopify.money_format.match(/^([^{]+)/);
          if (sfMatch) symbol = sfMatch[1];
        }
        return symbol + dollars;
      }

      return _original.call(this, cents, format);
    };
  }

  patchFormatMoney();
})();
